/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
};

export type ActionInput = {
  frameId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  wasInAir?: Maybe<Scalars['Boolean']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type BallAction = {
  __typename?: 'BallAction';
  matchId: Scalars['ID'];
  taskId: Scalars['ID'];
  frameId: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  wasInAir?: Maybe<Scalars['Boolean']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
  match?: Maybe<Match>;
};


export type Camera = {
  __typename?: 'Camera';
  id: Scalars['ID'];
  config: Scalars['JSONString'];
  matchId?: Maybe<Scalars['String']>;
  match?: Maybe<Match>;
};

export type CreateBallActions = {
  __typename?: 'CreateBallActions';
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateLabeledBatch = {
  __typename?: 'CreateLabeledBatch';
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateMatch = {
  __typename?: 'CreateMatch';
  match?: Maybe<Match>;
};

export type CreateTrackBatch = {
  __typename?: 'CreateTrackBatch';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteLabeledData = {
  __typename?: 'DeleteLabeledData';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteMatch = {
  __typename?: 'DeleteMatch';
  success?: Maybe<Scalars['Boolean']>;
};

export type Gap = {
  __typename?: 'Gap';
  firstFrame?: Maybe<Scalars['Int']>;
  lastFrame?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['Int']>;
  team?: Maybe<Scalars['String']>;
  frames?: Maybe<Array<Maybe<GapFrames>>>;
};

export type GapFrames = {
  __typename?: 'GapFrames';
  begin?: Maybe<Scalars['Int']>;
  end?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum GqTeamSide {
  Home = 'HOME',
  Away = 'AWAY',
  Referee = 'REFEREE'
}

/** An enumeration. */
export enum GqTeamType {
  Referee = 'REFEREE',
  Player = 'PLAYER',
  Keeper = 'KEEPER',
  Unknown = 'UNKNOWN',
  NonParticipant = 'NON_PARTICIPANT'
}

/** An enumeration. */
export enum GqTrackType {
  Player = 'PLAYER',
  Ball = 'BALL'
}


export type LabeledInput = {
  frameId?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type LabeledLocation = {
  __typename?: 'LabeledLocation';
  matchId: Scalars['ID'];
  taskId?: Maybe<Scalars['Int']>;
  frameId?: Maybe<Scalars['BigInt']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
  match?: Maybe<Match>;
};

export type Location = {
  __typename?: 'Location';
  id: Scalars['ID'];
  autonomous: Scalars['Boolean'];
  confidence?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  inAir?: Maybe<Scalars['Boolean']>;
  gameAlive?: Maybe<Scalars['Boolean']>;
  frameId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['Float']>;
  estimation?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  track?: Maybe<Track>;
};

export type LocationInput = {
  matchId?: Maybe<Scalars['String']>;
  mvtrackId?: Maybe<Scalars['String']>;
  type?: Maybe<GqTrackType>;
  teamType?: Maybe<GqTeamType>;
  team?: Maybe<GqTeamSide>;
  teamScore?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Int']>;
  numberScore?: Maybe<Scalars['Float']>;
  frameId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['BigInt']>;
  estimation?: Maybe<Scalars['Int']>;
  confidence?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  inAir?: Maybe<Scalars['Boolean']>;
  gameAlive?: Maybe<Scalars['Boolean']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type Match = {
  __typename?: 'Match';
  id: Scalars['ID'];
  runId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['BigInt']>;
  customerUser?: Maybe<Scalars['String']>;
  customerAccount?: Maybe<Scalars['String']>;
  cameras?: Maybe<Array<Maybe<Camera>>>;
  tracks?: Maybe<Array<Maybe<Location>>>;
  labeledTracks?: Maybe<Array<Maybe<LabeledLocation>>>;
  actions?: Maybe<Array<Maybe<BallAction>>>;
  locations?: Maybe<Array<Maybe<Location>>>;
  labeledLocations?: Maybe<Array<Maybe<LabeledLocation>>>;
  ballActions?: Maybe<Array<Maybe<BallAction>>>;
  playerGaps?: Maybe<Array<Maybe<Gap>>>;
  ballGaps?: Maybe<Gap>;
  locationFirstFrame?: Maybe<Scalars['Int']>;
  locationLastFrame?: Maybe<Scalars['Int']>;
  autonomousPlayerFrameCount?: Maybe<Scalars['Int']>;
  labeledPlayerFrameCount?: Maybe<Scalars['Int']>;
  autonomousBallFrameCount?: Maybe<Scalars['Int']>;
  labeledBallFrameCount?: Maybe<Scalars['Int']>;
};


export type MatchLocationsArgs = {
  tsFrom?: Maybe<Scalars['BigInt']>;
  tsTo?: Maybe<Scalars['BigInt']>;
  frameFrom?: Maybe<Scalars['BigInt']>;
  frameTo?: Maybe<Scalars['BigInt']>;
  sort?: Maybe<Scalars['Boolean']>;
  autonomous?: Maybe<Scalars['Boolean']>;
};


export type MatchLabeledLocationsArgs = {
  taskId?: Maybe<Scalars['Int']>;
  startFrame?: Maybe<Scalars['BigInt']>;
  count?: Maybe<Scalars['BigInt']>;
};


export type MatchBallActionsArgs = {
  taskId?: Maybe<Scalars['Int']>;
  frameFrom?: Maybe<Scalars['BigInt']>;
  frameTo?: Maybe<Scalars['BigInt']>;
};


export type MatchPlayerGapsArgs = {
  autonomous?: Maybe<Scalars['Boolean']>;
};


export type MatchBallGapsArgs = {
  autonomous?: Maybe<Scalars['Boolean']>;
};

export type Mutations = {
  __typename?: 'Mutations';
  createTrackBatch?: Maybe<CreateTrackBatch>;
  createLabeledBatch?: Maybe<CreateLabeledBatch>;
  createBallActions?: Maybe<CreateBallActions>;
  createMatch?: Maybe<CreateMatch>;
  deleteMatch?: Maybe<DeleteMatch>;
  deleteLabeledData?: Maybe<DeleteLabeledData>;
};


export type MutationsCreateTrackBatchArgs = {
  autonomous?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Array<Maybe<LocationInput>>>;
};


export type MutationsCreateLabeledBatchArgs = {
  locations?: Maybe<Array<Maybe<LabeledInput>>>;
  runId?: Maybe<Scalars['String']>;
  taskId?: Maybe<Scalars['Int']>;
};


export type MutationsCreateBallActionsArgs = {
  actions?: Maybe<Array<Maybe<ActionInput>>>;
  runId?: Maybe<Scalars['String']>;
  taskId?: Maybe<Scalars['Int']>;
};


export type MutationsCreateMatchArgs = {
  cameraConfigs?: Maybe<Scalars['String']>;
  customerAccount?: Maybe<Scalars['String']>;
  customerUser?: Maybe<Scalars['String']>;
  runId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['BigInt']>;
  videoTime?: Maybe<Scalars['Int']>;
};


export type MutationsDeleteMatchArgs = {
  autonomous?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  runId?: Maybe<Scalars['String']>;
};


export type MutationsDeleteLabeledDataArgs = {
  matchId?: Maybe<Scalars['String']>;
  runId?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  matches?: Maybe<Array<Maybe<Match>>>;
  match?: Maybe<Match>;
};


export type QueryMatchArgs = {
  id?: Maybe<Scalars['String']>;
  runId?: Maybe<Scalars['String']>;
};

export type Track = {
  __typename?: 'Track';
  matchId?: Maybe<Scalars['String']>;
  mvtrackId?: Maybe<Scalars['String']>;
  type?: Maybe<GqTrackType>;
  teamType?: Maybe<GqTeamType>;
  team?: Maybe<GqTeamSide>;
  number?: Maybe<Scalars['Int']>;
};

export type LocationsQueryVariables = Exact<{
  matchId: Scalars['String'];
  fromFrame: Scalars['BigInt'];
  toFrame: Scalars['BigInt'];
  autonomous: Scalars['Boolean'];
  sort: Scalars['Boolean'];
}>;


export type LocationsQuery = (
  { __typename?: 'Query' }
  & { match?: Maybe<(
    { __typename?: 'Match' }
    & Pick<Match, 'id' | 'runId' | 'locationFirstFrame' | 'locationLastFrame'>
    & { locations?: Maybe<Array<Maybe<(
      { __typename?: 'Location' }
      & Pick<Location, 'id' | 'autonomous' | 'frameId' | 'x' | 'y' | 'z' | 'estimation' | 'inAir' | 'gameAlive'>
      & { track?: Maybe<(
        { __typename?: 'Track' }
        & Pick<Track, 'type' | 'teamType' | 'team' | 'number'>
      )> }
    )>>> }
  )> }
);

export type GapsQueryVariables = Exact<{
  runId: Scalars['String'];
  autonomous: Scalars['Boolean'];
}>;


export type GapsQuery = (
  { __typename?: 'Query' }
  & { match?: Maybe<(
    { __typename?: 'Match' }
    & { playerGaps?: Maybe<Array<Maybe<(
      { __typename?: 'Gap' }
      & Pick<Gap, 'firstFrame' | 'lastFrame' | 'number' | 'team'>
      & { frames?: Maybe<Array<Maybe<(
        { __typename?: 'GapFrames' }
        & Pick<GapFrames, 'begin' | 'end'>
      )>>> }
    )>>>, ballGaps?: Maybe<(
      { __typename?: 'Gap' }
      & Pick<Gap, 'firstFrame' | 'lastFrame'>
      & { frames?: Maybe<Array<Maybe<(
        { __typename?: 'GapFrames' }
        & Pick<GapFrames, 'begin' | 'end'>
      )>>> }
    )> }
  )> }
);

export type MatchQueryVariables = Exact<{
  runId: Scalars['String'];
}>;


export type MatchQuery = (
  { __typename?: 'Query' }
  & { match?: Maybe<(
    { __typename?: 'Match' }
    & Pick<Match, 'id' | 'runId' | 'time' | 'customerUser' | 'customerAccount' | 'autonomousPlayerFrameCount' | 'labeledPlayerFrameCount' | 'autonomousBallFrameCount' | 'labeledBallFrameCount'>
  )> }
);


export const LocationsDocument = gql`
    query locations($matchId: String!, $fromFrame: BigInt!, $toFrame: BigInt!, $autonomous: Boolean!, $sort: Boolean!) {
  match(runId: $matchId) {
    id
    runId
    locationFirstFrame
    locationLastFrame
    locations(frameFrom: $fromFrame, frameTo: $toFrame, autonomous: $autonomous, sort: $sort) {
      id
      autonomous
      frameId
      x
      y
      z
      estimation
      inAir
      gameAlive
      track {
        type
        teamType
        team
        number
      }
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      fromFrame: // value for 'fromFrame'
 *      toFrame: // value for 'toFrame'
 *      autonomous: // value for 'autonomous'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const GapsDocument = gql`
    query gaps($runId: String!, $autonomous: Boolean!) {
  match(runId: $runId) {
    playerGaps(autonomous: $autonomous) {
      firstFrame
      lastFrame
      number
      team
      frames {
        begin
        end
      }
    }
    ballGaps(autonomous: $autonomous) {
      firstFrame
      lastFrame
      frames {
        begin
        end
      }
    }
  }
}
    `;

/**
 * __useGapsQuery__
 *
 * To run a query within a React component, call `useGapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGapsQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *      autonomous: // value for 'autonomous'
 *   },
 * });
 */
export function useGapsQuery(baseOptions: Apollo.QueryHookOptions<GapsQuery, GapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GapsQuery, GapsQueryVariables>(GapsDocument, options);
      }
export function useGapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GapsQuery, GapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GapsQuery, GapsQueryVariables>(GapsDocument, options);
        }
export type GapsQueryHookResult = ReturnType<typeof useGapsQuery>;
export type GapsLazyQueryHookResult = ReturnType<typeof useGapsLazyQuery>;
export type GapsQueryResult = Apollo.QueryResult<GapsQuery, GapsQueryVariables>;
export const MatchDocument = gql`
    query match($runId: String!) {
  match(runId: $runId) {
    id
    runId
    time
    customerUser
    customerAccount
    autonomousPlayerFrameCount
    labeledPlayerFrameCount
    autonomousBallFrameCount
    labeledBallFrameCount
  }
}
    `;

/**
 * __useMatchQuery__
 *
 * To run a query within a React component, call `useMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchQuery, MatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchQuery, MatchQueryVariables>(MatchDocument, options);
      }
export function useMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchQuery, MatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchQuery, MatchQueryVariables>(MatchDocument, options);
        }
export type MatchQueryHookResult = ReturnType<typeof useMatchQuery>;
export type MatchLazyQueryHookResult = ReturnType<typeof useMatchLazyQuery>;
export type MatchQueryResult = Apollo.QueryResult<MatchQuery, MatchQueryVariables>;